import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { resetPressedState } from '../../../../store/templates/templates';
import { deleteTemplate } from '../../../../store/templates/actions';
import useTemplates from '../../use-templates';
import Modal from 'ud-ui/components/modal';
import { UDButton, UDText } from 'ud-ui/components';

function useDeleteModal() {
  const dispatch = useDispatch();
  const { activeTemplate, isProcessed, isFinished, currentProcess } = useTemplates();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onSubmit = useCallback(() => {
    if (!activeTemplate) return;
    dispatch(deleteTemplate({ id: activeTemplate.id }));
  }, [activeTemplate, dispatch]);

  useEffect(() => {
    if (!isFinished) {
      return;
    }
    if (currentProcess !== 'delete template') {
      return;
    }
    close();
    dispatch(resetPressedState());
  }, [isFinished, close, dispatch, currentProcess]);

  return {
    modal: (
      <Modal show={isOpen} onClose={close}>
        <Modal.Header title="Удаление шаблона" />
        <Modal.Body>
          <UDText isNew type="text-1">
            Вы уверены, что хотите удалить этот шаблон?
          </UDText>
          <UDText isNew type="text-1">
            Это действие нельзя отменить.
          </UDText>
        </Modal.Body>
        <Modal.Footer>
          <UDButton variant="secondary" type="button" onClick={close} loading={isProcessed} stretch>
            Отмена
          </UDButton>
          <UDButton variant="primary" type="button" onClick={onSubmit} loading={isProcessed} stretch>
            Удалить
          </UDButton>
        </Modal.Footer>
      </Modal>
    ),
    close,
    open,
  };
}

export default useDeleteModal;
